import { boolean, object, string } from "superstruct";

export const DiscountCodesSchema = object({
    code: string(),
    applicable: boolean(),
});
